export default "__VITE_ASSET__09c283b7__"